import { lazy } from 'react';
import { RouteConfig } from 'types/routing';

// List of routes available in the current application
const routes: Array<RouteConfig> = [
  {
    component: lazy(
      () => import(/* webpackChunkName: 'accounts-list' */ 'pages/BankAccountListPage'),
    ),
    id: 'accounts:list',
    path: '/',
    title: 'Accounts',
  },
  {
    component: lazy(
      () => import(/* webpackChunkName: 'accounts-error' */ 'pages/BankAccountErrorPage')
    ),
    id: 'accounts:error',
    layout: false,
    path: '/error',
    title: 'Access Denied',
  },
  {
    breadcrumbs: [{ id: 'accounts:list' }],
    component: lazy(
      () => import(/* webpackChunkName: 'accounts-create' */ 'pages/BankAccountCreatePage'),
    ),
    id: 'accounts:create',
    path: '/accounts/create',
    title: 'Create Account',
  },
  {
    breadcrumbs: [{ id: 'accounts:list' }],
    component: lazy(
      () => import(/* webpackChunkName: 'accounts-edit' */ 'pages/BankAccountEditPage'),
    ),
    id: 'accounts:edit',
    path: '/accounts/:id',
    title: 'Edit Account',
  },
  {
    component: lazy(() => import(/* webpackChunkName: 'login' */ 'pages/LoginPage')),
    id: 'auth:login',
    layout: false,
    path: '/login',
    restricted: false,
    title: 'Login',
  },
  {
    component: lazy(
      () => import(/* webpackChunkName: 'reconciliation' */ 'pages/ReconciliationPage'),
    ),
    id: 'reconciliation',
    path: '/reconciliation',
    title: 'Reconciliation',
  },
  {
    component: lazy(() => import(/* webpackChunkName: 'not-found' */ 'pages/NotFoundPage')),
    id: 'error:404',
    layout: false,
    title: 'Not Found',
  },
];

export default routes;
